var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjectStorageOss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620.544 170.496c-155.648 0-285.696 107.008-321.024 251.904-3.072 0-6.144 0-9.728-0.512-113.152 0-204.8 91.648-204.8 204.8 0 54.272 21.504 106.496 59.904 144.384 38.4 38.4 90.624 59.904 144.896 59.904 54.272 0 106.496-21.504 144.896-60.416 32.256-32.256 50.176-75.264 55.296-122.88l-74.24-5.632c-16.896-2.048-22.016-14.848-11.776-28.16l125.44-155.136c10.24-13.312 24.064-11.776 30.72 3.584l71.168 174.08c6.656 15.872-1.536 26.624-18.432 24.576l-55.296-5.12c-6.144 57.856-32.256 108.544-68.608 148.992 41.472 17.92 86.016 27.136 131.584 27.136 182.784 0 330.752-147.968 330.752-330.752 0-182.784-147.968-330.752-330.752-330.752z",
    fill: "#FF6A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectStorageOss);
export default __webpack_public_path__ + "static/media/object-storage-oss.13f4e1c1d4536970022433d61247c6d9.svg";
export { ForwardRef as ReactComponent };